<template>
  <!-- 页面布局 -->
  <el-container class="index-con">
    <el-aside :class="showclass">
      <!-- <div v-if="!logBool">
        <img :src="imglogo" alt="" class="logo_img" style="margin: 10px 0" />
      </div> -->
      <div class="name">
        {{ name ? name : platformTitle }}
      </div>
      <leftnav></leftnav>
    </el-aside>
    <el-main class="main_content">
      <el-container>
        <el-header :class="headerclass">
          <navcon></navcon>
        </el-header>
        <el-main>
          <el-main :class="mainclass">
            <keep-alive>
              <router-view></router-view>
            </keep-alive>
            <slot />
          </el-main>
        </el-main>
      </el-container>
    </el-main>
  </el-container>
</template>
<script>
// 导入组件
import navcon from "../components/topheader";
import leftnav from "../components/leftnav";
import { mapGetters } from "vuex";

export default {
  name: "index",
  data() {
    return {
      showclass: "asideshow",
      showtype: false,
      headerclass: "headershow",
      mainclass: "mainshow",
      imglogo: require("../assets/mylogo.png"),
      logBool: true,
      screenWidth: document.body.clientWidth,
      timer: false,
      name: null,
    };
  },
  // 注册组件
  components: {
    navcon,
    leftnav,
  },
  computed: {
    ...mapGetters(["platformName"]),
    platformTitle: {
      get() {
        return this.platformName ? this.platformName : this.$t('login.formatName');
      },
    },
  },
  watch: {
    screenWidth(val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = val;
        this.timer = true;
        let that = this;
        setTimeout(function () {
          // 打印screenWidth变化的值
          console.log(that.screenWidth);
          that.$root.Bus.$emit("screenWidth", that.screenWidth);
          that.timer = false;
        }, 400);
      }
    },
  },
  mounted() {
    const that = this;
    // 根据屏幕宽度设置左侧导航盒子宽度
    this.$root.Bus.$emit("screenWidth", this.screenWidth);
  },
  methods: {},
  created() {
    // 监听
    this.$root.Bus.$on("toggle", (value) => {
      this.logBool = value;
      if (value) {
        this.showclass = "asideshow";
        this.headerclass = "headershow";
        this.mainclass = "mainshow";
        this.name = null;
      } else {
        setTimeout(() => {
          this.name = this.$t('screen.chartTitle14');
          this.showclass = "aside";
          this.headerclass = "headerhide";
          this.mainclass = "mainhide";
        }, 300);
      }
    });
  },
  beforeUpdate() {},
  // 挂载前状态(里面是操作)
  beforeMount() {},
};
</script>
<style lang="less" scoped>
@bg: #364150;
@contentBg: #f1f4f6;

.name {
  color: #fff;
  font-size: 12px;
  // font-weight: bold;
  height: 50px;
  line-height: 50px;
  background-color: #009688;
}

.logo_img {
  width: 30px;
  height: 30px;
  vertical-align: middle;
  margin-right: 5px;
}

.index-con {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}

.el-main.main_content {
  padding: 0;
  background-color: @contentBg;
}

.aside {
  width: 64px !important;
  /*height: 100%;*/
  // background-color: #334157;
  background-color: @bg;
  margin: 0px;
}

.asideshow {
  width: 200px !important;
  /*height: 100%;*/
  // background-color: #334157;
  background-color: @bg;
  margin: 0px;
}

.index-header,
.index-main {
  padding: 0px;
  border-left: 0px solid #333;
}

/deep/ .el-header {
  height: 20px !important;
  line-height: 20px;
  padding: 0 10px;
}

.headershow {
  margin-bottom: 0;
  // position: fixed;
  // left: 240px;
  // left: 0px;
  // right: 0;
  padding: 0;
}

.headerhide {
  margin-bottom: 0;
  // position: fixed;
  // left: 64px;
  // right: 0;
  padding: 0;
}

.asideshow,
.aside {
  // padding: 0;
  // position: fixed;
  /*top: 0px;*/
  // top: 60px;
  // bottom: 0;
  overflow: auto;
}

.asideshow::-webkit-scrollbar,
.aside::-webkit-scrollbar {
  display: none;
}

.mainshow {
  position: absolute;
  /*top: 40px;*/
  top: 60px;
  left: 200px;
  right: 0;
  bottom: 0;
  overflow-y: scroll;
  overflow-x: hidden;
}

.mainhide {
  position: absolute;
  top: 60px;
  left: 64px;
  right: 0;
  bottom: 0;
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/layout/index.vue